export const STATUS = {
  planned: 'planned',
  on_going: 'on_going',
  finished: 'finished'
};

export const STATUS_VARIANTS = {
  [STATUS.planned]: 'info',
  [STATUS.on_going]: 'success',
  [STATUS.finished]: 'light'
};

export const TAB = {
  activities: 'activities',
  questionnaires: 'questionnaires',
  adherence: 'adherence',
  goal_tracking: 'goal_tracking'
};

export const TYPE = {
  preset: 'preset'
};
